import type { FC } from "react";
import React, { createContext, useContext } from "react";

import type { BrandProviderProps, Brands } from "./types";

const BrandContext = createContext<Brands>("ED");

export const useBrand = () => useContext(BrandContext);

const BrandProvider: FC<BrandProviderProps> = ({ brand, children }) => {
  return (
    <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
  );
};

export default BrandProvider;
